import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

function GetHeader() {
  const {
    menuButton: {
      childImageSharp: { fixed: menuButton },
    },
  } = useStaticQuery(graphql`
    {
      menuButton: file(relativePath: { eq: "menubutton.png" }) {
        childImageSharp {
          fixed(width: 70) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  let getHeader = () => {
    // For transform animation to header
    document.getElementsByTagName("header")[0].classList.add("active")
    document.getElementById("headerWrapper").firstChild.classList.add("active")
    document.getElementsByTagName("main")[0].firstChild.classList.add("active")
    // To avoid scrolling option on header, so making overflow hidden
    setTimeout(() => (document.body.style.overflow = "hidden"), 0)
  }

  return (
    <span onClick={getHeader} role="button" tabIndex={0}>
      <Image
        fixed={menuButton}
        alt="menu button"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          cursor: "pointer",
          zIndex: "6",
        }}
      />
    </span>
  )
}

export default GetHeader
